import styled, {FlattenSimpleInterpolation, css} from 'styled-components'
import {white, yellow} from '@modifi/colors'
import {media as _media, H4, Row} from '@modifi/ui'

import {colorMap} from '../common'

type mediaType = Record<string, any>

const media = _media as mediaType

type WrapperProps = {
  backgroundColor?: string
}

export const Wrapper = styled.div<WrapperProps>`
  height: 72px;
  background: transparent;
  position: relative;
  ${({backgroundColor}): FlattenSimpleInterpolation | string =>
    backgroundColor && colorMap?.[backgroundColor]
      ? css`
          background-color: ${colorMap?.[backgroundColor]};
        `
      : ''}
`

export const StyledRow = styled(Row)`
  width: 100%;
  margin: 0 auto;
`

export const StyledH4 = styled(H4)`
  font-size: 16px;
  ${media.md`
    font-size: 32px;
  `}
  ${media.xs`
    text-align: center;
  `}
  margin: 0;
`

export const OverlayWrapper = styled.div`
  position: absolute;
  display: flex;
  border-radius: 6px;
  box-shadow: 0 4px 16px rgba(63, 136, 198, 0.11);
  min-width: 80%;
  min-height: 107px;
  top: 8px;
  z-index: 100;
  left: 50%;
  transform: translate(-50%);
  background: ${white};
  padding: 8px;
  ${media.md`
    padding: 16px;
    min-width: 70%;
  `}
  ${media.lg`
    min-width: 60%;
  `}
`

export const CTAWrapper = styled.div`
  display: flex;
  justify-content: center;
  ${media.xs`
    margin-top: 8px;
  `}
`

export const DummyComponent1ForStory = styled.div`
  height: 80px;
`

export const DummyComponent2ForStory = styled.div`
  height: 220px;
  background-color: ${yellow};
`
